import React, { useEffect, useRef } from "react";
import Modal from "react-modal";
import cx from "classnames";
import { useInView } from "react-intersection-observer";
import { CircleButton } from "../buttons/CircleButton";
import { Docs } from "./Docs";
import "./DocModal.scss";
import { useValidatedDocuments } from "./useValidatedDocuments";
export const DocModal = ({ active, onRequestClose, header, printEnabled = true, modalAnnouncement, appElement = "#root", selectPlaceholder, docName, variableValues, docList, }) => {
    const [ref, inView] = useInView();
    const elem = useRef(null);
    const printRef = useRef(null);
    const styleElem = useRef();
    const validatedDocuments = useValidatedDocuments(docList);
    const requestClose = () => {
        if (styleElem.current) {
            document.head.removeChild(styleElem.current);
            styleElem.current = undefined;
        }
        onRequestClose();
    };
    useEffect(() => {
        var _a;
        if (active && !styleElem.current) {
            const printCss = `@media print {
        ${appElement} { display: none }
        @page { margin: 2cm 3cm }
      }`;
            const style = document.createElement("style");
            document.head.appendChild(style);
            styleElem.current = style;
            (_a = style.sheet) === null || _a === void 0 ? void 0 : _a.insertRule(printCss);
        }
        return () => {
            if (styleElem.current && !active) {
                document.head.removeChild(styleElem.current);
                styleElem.current = undefined;
            }
        };
    }, [appElement, active]);
    return (React.createElement(Modal, { appElement: document.querySelector(appElement), isOpen: active, contentLabel: modalAnnouncement, onRequestClose: requestClose, className: "lysa-ui-doc-modal", style: {
            overlay: {
                backgroundColor: "rgba(0, 0, 0, 0.5)",
                position: "fixed",
                display: "flex",
                justifyContent: "center",
                padding: "40px 0",
                zIndex: 9999,
            },
        }, contentElement: (props, children) => (React.createElement("div", Object.assign({}, props, { style: { borderRadius: "1px solid #ccc" } }),
            React.createElement("div", Object.assign({}, props, { style: { top: 0, bottom: 0 } }), children))) },
        React.createElement("div", { className: cx("doc-modal", { "show-arrow": !inView }) },
            React.createElement("div", { className: "scroll-ref", ref: elem }),
            React.createElement("div", { className: "modal-scroll-button-wrapper" },
                printEnabled && (React.createElement(CircleButton, { className: "modal-print-button", onClick: window.print, icon: "Print" })),
                React.createElement("span", null),
                React.createElement(CircleButton, { onClick: () => {
                        var _a;
                        return (_a = elem === null || elem === void 0 ? void 0 : elem.current) === null || _a === void 0 ? void 0 : _a.scrollIntoView({
                            block: "start",
                            behavior: "smooth",
                        });
                    }, icon: "Up" })),
            React.createElement("div", { ref: ref }),
            React.createElement("div", { className: "modal-header" },
                header ? React.createElement("strong", null, header) : React.createElement("div", null),
                React.createElement("div", { className: "modal-actions" },
                    printEnabled && (React.createElement(CircleButton, { className: "modal-print-button", onClick: window.print, icon: "Print" })),
                    React.createElement(CircleButton, { onClick: requestClose, icon: "Cancel" }))),
            React.createElement("div", { ref: printRef, className: "modal-print-body" },
                React.createElement(Docs, { variableValues: variableValues, docName: docName, validatedDocuments: validatedDocuments, selectPlaceholder: selectPlaceholder })))));
};
